import styled, { css } from 'styled-components';
import { focusVisibleMixin } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { Price, PriceComponent } from '../../../common';
import {
  Description,
  DescriptionComponent,
  Icons,
  IconsComponent,
  Image,
  ImageComponentContainer,
  Name,
  NameComponent,
  StyledIconsItem
} from '../items-parts';
import type { SelectedItemLayout } from './ItemLayout';

export function ItemLayoutTwo({
  data,
  width = 100,
  priceWidth,
  setPriceWidth,
  onClick,
  onKeyDown
}: SelectedItemLayout) {
  const { itemElements = [], showDefaultImage, popupEnabled } = useSettings();
  const { name, image, price, description, badges = [] } = data;

  const interactiveProps = popupEnabled
    ? {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown
      }
    : {};

  return (
    <Component
      {...interactiveProps}
      style={{
        width: `calc(${width}% - 48px)`
      }}
      _priceWidth={priceWidth}
    >
      {itemElements.includes('image') &&
        (image || (!image && showDefaultImage)) && (
          <Image image={image} alt="" />
        )}

      <Info>
        <NameAndPrice>
          <NameContainer>
            <Name>
              {name}

              {badges?.length > 0 && itemElements.includes('badges') && (
                <Icons icons={badges} />
              )}
            </Name>
          </NameContainer>

          {price && itemElements.includes('price') && (
            <Price
              price={price}
              priceWidth={priceWidth}
              setPriceWidth={setPriceWidth}
            />
          )}
        </NameAndPrice>

        {description && itemElements.includes('description') && (
          <Description>{description}</Description>
        )}
      </Info>
    </Component>
  );
}

const Component = styled.div<{ _priceWidth: number }>`
  display: flex;
  margin: 16px 24px;

  ${ImageComponentContainer} {
    width: 120px;
    height: 120px;
  }

  ${NameComponent} {
    text-align: left;
    flex-shrink: 1;
    max-width: 100%;
    overflow: hidden;
    margin-right: 10px;
    position: relative;
  }

  ${DescriptionComponent} {
    margin-right: ${({ _priceWidth }) => _priceWidth + 12}px;
  }

  &:hover,
  &:focus-visible {
    ${({ theme: { popupEnabled } }) =>
      popupEnabled &&
      css`
        cursor: pointer;

        ${NameComponent} {
          text-decoration: underline;
        }
      `}
  }

  ${focusVisibleMixin()}

  ${PriceComponent} {
    align-self: baseline;
    white-space: nowrap;
  }
`;
const Info = styled.div`
  width: 100%;
`;
const NameAndPrice = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
const NameContainer = styled.div`
  color: #111111;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: baseline;

  ${IconsComponent} {
    display: inline-flex;
    margin-left: 6px;
  }

  ${StyledIconsItem} {
    width: ${({
      theme: {
        itemNameFontStyle: { fontSize }
      }
    }) => fontSize}px;
    height: ${({
      theme: {
        itemNameFontStyle: { fontSize }
      }
    }) => fontSize}px;
    padding: 0;
    margin: 0 4px;
  }
`;
